<template>
  <div style="width: 400px;height: 300px;margin: auto;">
    <a-form class="mult_operation" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :colon="false" label-align="left">
      <section>
        <a-row type="flex" align="middle">
          <a-col :span="24">
            <a-form-item label="报表类型">
              <a-radio-group v-model:value="formData.report_type" button-style="solid">
                <a-radio :value="'工时'"> 工时报表 </a-radio>
                <a-radio :value="'财务报表'"> 财务报表 </a-radio>
                <a-radio :value="'运营数据'"> 运营数据 </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row type="flex" align="middle">
          <a-col :span="24">
            <a-form-item label="日期范围" >
              <a-range-picker :placeholder="['开始日期', '结束日期']" v-model:value="defaultRange" separator="到" :format="[dateRangeFormat, dateRangeFormat]" :ranges="dateRanges" :disabled-date="disabledDateRange" @change="onDateRangeChange"  />
            </a-form-item>
          </a-col>
        </a-row>
      </section>
    </a-form>
    <a-button @click="handleOk" style="margin: auto;">导出excel</a-button>
  </div>
</template>

<script>
import { addfinance } from '@/api/finance/finance.js';
import moment from 'moment';
import {ref} from "vue";
export default {
  // name: 'VerifyData',
  // emits: ['afterSave'],
  data() {
    const dateRangeFormat = 'YYYY-MM-DD';
    const dateRanges = {
      昨天: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      最近三天: [moment().subtract(2, 'days'), moment()],
      本周: [moment().startOf('week'), moment.min(moment(), moment().endOf('week'))],
      最近七天: [moment().subtract(6, 'days'), moment()],
      本月: [moment().startOf('month'), moment.min(moment(), moment().endOf('month'))],
      最近三十天: [moment().subtract(29, 'days'), moment()],
      最近九十天: [moment().subtract(89, 'days'), moment()],
    };
    //禁止rangepick选择今天开始的日期
    const disabledDateRange = current => {
      return current && current > moment().add(1, 'days').startOf('day');
      // return moment().add(1, 'days').startOf('day');
    };
    // rangepicker默认选中日期
    const defaultRange = ref([moment(), moment()]);
    const empty = { start_date: moment().format(dateRangeFormat), end_date: moment().format(dateRangeFormat),report_type:'工时'};
    return {
      empty,
      formData: { ...empty },
      dateRanges,
      defaultRange,
      dateRangeFormat,
      disabledDateRange,
    };
  },
  methods: {
    // 开始时间结束时间选择
    onDateRangeChange(val, dateString) {
      console.error(dateString);
      this.formData.startDate = dateString[0];
      this.formData.endDate = dateString[1];
      console.error('传送成功')
    },
    // 点击保存
    async handleOk() {
      this.tableLoading = true;
      let obj = { start_date:this.formData.startDate,end_date:this.formData.endDate,report_type:this.formData.report_type};
      let res ;
      res = await addfinance(obj);
      if (res.code === 0) {
        this.$emit('afterSave');
        this.$message.success('稍等片刻,数据同步已提交后台！');
        this.visible = false;
      }else{
        this.$message.error(res.msg);
        this.visible = false;
      }
      this.tableLoading = false;
      return ;
    },
  },
};
</script>

<style  lang="less">
.mult_operation {
  overflow: auto;

  .ant-form-item-label {
    line-height: 40px;
  }
  .anticon-question-circle svg {
    font-size: 14px;
  }
  .ant-calendar-picker-input {
    height: 32px !important;
  }
  .ant-radio-button-wrapper {
    width: 96px;
    text-align: center;
  }
}

</style>
